import React, { useContext, useEffect } from "react";
import { Title } from "../../Atoms";
import { NOTIF_TYPES } from "../../../Library/constants";
import { StoreContext } from "../../../Library/contexts";
import { getLocalisedDate, getLocalisedTime, isSameDay } from "../../../Library/datetime";
import "./styles.css";

const getSlot = (ts) => {
  const TODAY_START = new Date().setHours(0, 0, 0, 0);
  const YESTERDAY_START = new Date(TODAY_START).setDate(new Date(TODAY_START).getDate() - 1);

  if (ts >= TODAY_START) return "Today";
  if (ts >= YESTERDAY_START) return "Yesterday";
  return getLocalisedDate(ts);
};

const NotifList = ({ full }) => {
  const { notifications, setNotifications } = useContext(StoreContext);

  useEffect(() => {
    if (full) setNotifications((old) => ({ ...old, unreadCount: 0 }));
  }, [ full, setNotifications ]);

  const renderSlot = ({ ts }) => {
    return (
      <div key={ts} className="notif-slot"> {getSlot(ts)} </div>
    );
  };

  const renderNotif = (notification, isNew) => {
    const notificationType = NOTIF_TYPES[notification.typ];

    return (
      <div key={notification.idx} className="notif-item">
        <div className="notif-item-icon">
          {notificationType.icon}
        </div>

        <div className="notif-item-main">
          <div className="notif-item-header">{notificationType.label}</div>
          <div className="notif-item-label">{notification.text}</div>
        </div>

        <div className="notif-item-time">
          {getLocalisedTime(notification.ts, true, true)}
        </div>

        <div className="notif-item-end">
          <div className={"notif-item-badge " + (isNew ? "notif-item-badge-active" : "")} />
        </div>
      </div>
    );
  };

  const renderNotifications = () => {
    if (!notifications || !notifications.notifs.length) return (
      <div className="notif-slot"> No New Notifications </div>
    );

    const render = [];

    notifications.notifs.forEach((notif, i) => {
      if (!full && (i > 5)) return;

      const prevNotif = notifications.notifs[i - 1];
      if (!prevNotif || !isSameDay(notif.ts, prevNotif.ts)) render.push(renderSlot(notif));
      render.push(renderNotif(notif, i < notifications.unreadCount));
    });

    return render;
  };

  return (
    <>
      <div className="notif-header">
        <Title>Notifications</Title>
      </div>
      {renderNotifications()}
    </>
  );
};

export default NotifList;
